import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局挂载
let locale = localStorage.getItem("locale");
document.documentElement.setAttribute("lang", locale);
import ar from "element-ui/lib/locale/lang/ar";
import br from "element-ui/lib/locale/lang/pt-br";
import de from "element-ui/lib/locale/lang/de";
import en from "element-ui/lib/locale/lang/en";
import es from "element-ui/lib/locale/lang/es";
import fr from "element-ui/lib/locale/lang/fr";
import it from "element-ui/lib/locale/lang/it";
import ja from "element-ui/lib/locale/lang/ja";
import tr from "element-ui/lib/locale/lang/tr-TR";
export const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
  messages: {
    ar: {
      ...ar,
      ...require("./module/ar"),
    },
    br: {
      ...br,
      ...require("./module/br"),
    },
    de: {
      ...de,
      ...require("./module/de"),
    },
    en: {
      ...en,
      ...require("./module/en"),
    },
    es: {
      ...es,
      ...require("./module/es"),
    },
    fr: {
      ...fr,
      ...require("./module/fr"),
    },
    it: {
      ...it,
      ...require("./module/it"),
    },
    jp: {
      ...ja,
      ...require("./module/jp"),
    },
    tr: {
      ...tr,
      ...require("./module/tr"),
    },
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/langurage/i18n.js